/* unplugin-vue-components disabled */import script from "./examine.vue?vue&type=script&setup=true&lang=js"
export * from "./examine.vue?vue&type=script&setup=true&lang=js"

import "./examine.vue?vue&type=style&index=0&id=1def7fc2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1def7fc2"]])

export default __exports__